














































































import { Vue, Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Searchfield from '@/components/Form/Searchfield/index.vue';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import DownloadIcon from '@/components/Icons/DownloadIcon/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import UserList from '@/components/Table/UserList/index.vue';
import UserFilterDropdown from '@/components/Form/UserFilterDropdown/index.vue';
import UserModule from '@/store/modules/user';
import PermissionMixin from '../../mixins/PermissionMixin';
import UserUtil from '../../util/UserUtil';

@Component({
  components: {
    Searchfield,
    DownloadIcon,
    PrimaryButton,
    UserList,
    Dropdown,
    UserFilterDropdown,
  },
})
export default class Users extends mixins(PermissionMixin) {
  private search: string = '';

  private searchRole: any = [];

  private searchStatus: any = [];

  get roleItems() {
    const roles = Object.entries(UserUtil.RoleMap).map(([key, value]) => ({
      text: value,
      value: key,
    }));
    if (this.fwManager) {
      const role = roles.filter(e => e.value !== 'fw_admin');
      return role;
    }
    if (this.adminUser) {
      return roles;
    }
    return '';
  }

  private userItems = [
    {
      text: 'Active',
      value: 'Active',
    },
    {
      text: 'Deactivated',
      value: 'Deactivated',
    },
  ];

  public onRole(data: any) {
    this.updateQuery(JSON.stringify(data), 'partnerowner');
  }

  public onStatus(data: any) {
    this.updateQuery(JSON.stringify(data), 'status');
  }

  public updateQuery(data: any, key: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [key]: data,
      },
    });
  }

  public mounted() {
    if (this.$route.query) {
      const {
        partnerowner,
        status,
      } = this.$route.query;
      if (partnerowner) {
        this.searchRole = JSON.parse((partnerowner as any));
      }
      if (status) {
        this.searchStatus = JSON.parse((status as any));
      }
    }
  }

  public clearSearchAll() {
    this.searchRole = '';
    this.searchStatus = '';
    this.resetQuery();
  }

  public resetQuery() {
    this.$router.replace({
      query: {},
    });
  }

  public onCreateUser() {
    this.$router.push('/users/create-user');
  }

  get fwManager() {
    if (UserModule.currentRole === 'fw_manager') {
      return UserModule.currentRole;
    }
    return null;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin') {
      return UserModule.currentRole;
    }
    return null;
  }
}
